import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { upcomingSessions, BUILT_STORAGE_KEY } from '../config/builtSessions';
import './Built.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ME = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/2t98fqnu_untitled-0235.webp';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

const SessionPicker = ({ sessions, value, onChange }) => (
  <fieldset className="bt-times" data-testid="built-times">
    <legend className="bt-times-q">which time works for you?</legend>
    <div className="bt-pills">
      {sessions.map((s) => (
        <button
          key={s.id}
          type="button"
          aria-pressed={value === s.id}
          className={`bt-pill${value === s.id ? ' is-on' : ''}`}
          onClick={() => onChange(value === s.id ? null : s.id)}
          data-testid={`built-time-${s.id}`}
        >
          {s.label}
        </button>
      ))}
    </div>
  </fieldset>
);

export default function Built() {
  const navigate = useNavigate();
  const sessions = useMemo(() => upcomingSessions(), []);
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [sessionId, setSessionId] = useState(null);
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    document.title = 'get paid more · kristen hinman';
    axios.post(`${API}/built/view`, { page: 'built' }).catch(() => {});
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!firstName.trim() || !EMAIL_RE.test(email.trim())) {
      setError("need your first name & email for this part");
      return;
    }
    setError('');
    setSending(true);
    const session = sessions.find((s) => s.id === sessionId) || null;
    const params = new URLSearchParams(window.location.search);
    const utms = Object.fromEntries(UTM_KEYS.map((k) => [k, params.get(k) || null]));
    try {
      await axios.post(`${API}/built/signup`, {
        first_name: firstName.trim(),
        email: email.trim(),
        session_id: session?.id || null,
        session_label: session?.label || null,
        session_start: session?.start || null,
        ...utms,
      });
    } catch (err) {
      // still continue to the thank you page
    }
    sessionStorage.setItem(BUILT_STORAGE_KEY, JSON.stringify({
      first_name: firstName.trim(),
      email: email.trim(),
      session: session ? { id: session.id, label: session.label, start: session.start } : null,
    }));
    navigate('/opportunity');
  };

  return (
    <div className="bt-page" data-testid="built-page">
      <main className="bt-left">
        <div className="bt-inner">
          <div className="bt-byline">
            <img src={ME} alt="kristen hinman" className="bt-avatar" />
            <span>hi, i&apos;m kristen</span>
          </div>
          <h1 className="bt-h1" data-testid="built-headline">
            get paid more <span className="bt-hl-line"><span className="bt-hl">for what you&apos;ve already built</span></span>
          </h1>
          <p className="bt-highlight">a free 30-minute live call for women who are great at what they do &amp; still only get paid when they show up.</p>

          <form className="bt-form" onSubmit={onSubmit} noValidate data-testid="built-form">
            <input
              type="text" placeholder="first name" autoComplete="given-name" aria-label="first name"
              value={firstName} onChange={(e) => setFirstName(e.target.value)} data-testid="built-first-name"
            />
            <input
              type="email" placeholder="email" autoComplete="email" inputMode="email" aria-label="email"
              value={email} onChange={(e) => setEmail(e.target.value)} data-testid="built-email"
            />
            {sessions.length > 0 && <SessionPicker sessions={sessions} value={sessionId} onChange={setSessionId} />}
            {error && <p className="bt-error" role="alert" data-testid="built-error">{error}</p>}
            <button type="submit" className="bt-submit" disabled={sending} data-testid="built-submit">
              save my seat
            </button>
            <p className="bt-under">can&apos;t make either one? sign up anyway &amp; i&apos;ll personally make sure you get the recording.</p>
            <p className="bt-tiny">you&apos;ll also get my emails. unsubscribe anytime.</p>
          </form>
        </div>
      </main>
    </div>
  );
}
